document.addEventListener("DOMContentLoaded", function () {
  const observer = new MutationObserver(() => {
    const widgets = document.querySelectorAll(".custom-vstar-rating-widget .vstar-star");
    if (widgets.length > 0) {
      widgets.forEach(starContainer => {
        const firstStar = starContainer.querySelector(".star-item");
        const ratingText = starContainer.querySelector(".tt-rating-text");
        const reviewNum = parseInt(starContainer.getAttribute("data-review-num")) || 0;

        if (reviewNum === 0 && firstStar && firstStar.classList.contains("nostar")) {
          starContainer.querySelectorAll(".star-item").forEach(star => {
            star.style.display = "none";
          });
          firstStar.style.display = "inline-block";
          firstStar.classList.remove("nostar");
          firstStar.classList.add("filled-star");

          if (ratingText) ratingText.textContent = "Be first to review";
        }
      });
      observer.disconnect();
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});
